import React from 'react';
import ChargingHabitGraph from '@di-shared/features/diag/ev-battery/ChargingHabitGraph';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

interface EvBatteryChargingHabitBottomSheetProps {
  onExit: () => void;
  graphItems: {start: number; end: number; title: string; tooltipText: string}[];
  showCautionZone: boolean;
  avgMinSoc: number;
  avgMaxSoc: number;
}

export const DEFAULT_CAUTION_LEVEL = 10;
const BATTERY_AVERAGE_THRESHOLD = 20;

function EvBatteryChargingHabitBottomSheet({
  graphItems,
  showCautionZone,
  avgMinSoc,
  avgMaxSoc,
  onExit,
}: EvBatteryChargingHabitBottomSheetProps) {
  const {t} = useInferableTranslation();
  const titleSubMessage =
    avgMinSoc >= BATTERY_AVERAGE_THRESHOLD
      ? t('T30465_range', {range: `${avgMinSoc}~${avgMaxSoc}%`})
      : t('T30484_$range', {range: `${avgMinSoc}~${avgMaxSoc}%`});

  return (
    <div className="bottom_sheet bottom_sheet_battery">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T30456')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={onExit}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{titleSubMessage}</strong>
          <ChargingHabitGraph
            guideLines={[avgMinSoc, avgMaxSoc]}
            cautionLevel={DEFAULT_CAUTION_LEVEL}
            showCautionZone={showCautionZone}
          >
            {graphItems.map(({title, start, end, tooltipText}) => (
              <ChargingHabitGraph.Item
                key={title}
                start={start}
                end={end}
                title={title}
                tooltipText={tooltipText}
              />
            ))}
          </ChargingHabitGraph>
          {showCautionZone && (
            <div className="battery_guide_box">
              <strong className="title">
                <span className="ic ic_filled_notice" />
                {t('T30466')}
              </strong>
              <p className="desc">{t('T30467_percent', {percent: 10})}</p>
            </div>
          )}

          <ul className="notice_list">
            <li className="notice_item">{t('T30468')}</li>
            <li className="notice_item">{t('T30469')}</li>
            <li className="notice_item">{t('T30470')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default EvBatteryChargingHabitBottomSheet;
